import { render, staticRenderFns } from "./BuscarEmpresas.vue?vue&type=template&id=31849520&"
import script from "./BuscarEmpresas.vue?vue&type=script&lang=js&"
export * from "./BuscarEmpresas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports